import type { ApiClient } from '@/shared/api';
import type {
  ListSchedulesOptions,
  ScheduleCancelResponseWire,
  ScheduleListResponseWire,
  SchedulesApiClient,
} from './types';

function toQuery(options: ListSchedulesOptions | undefined) {
  return {
    agent_id: options?.agentId,
    include_cancelled: options?.includeCancelled,
    limit: options?.limit,
    offset: options?.offset,
  };
}

export function createSchedulesApi(client: ApiClient): SchedulesApiClient {
  return {
    async listSchedules(options) {
      return client.request<ScheduleListResponseWire>({
        path: '/api/v1/schedules',
        query: toQuery(options),
        signal: options?.signal,
      });
    },
    async cancelSchedule(triggerId, signal) {
      return client.request<ScheduleCancelResponseWire>({
        method: 'DELETE',
        path: `/api/v1/schedules/${encodeURIComponent(triggerId)}`,
        signal,
      });
    },
  };
}
